import React from 'react';
import { } from 'prop-types';
import cx from 'classnames';

import { Bar, BarItem, Icon } from '../';

const CLASS_ROOT = 'social';

const propTypes = {};

const Social = ({ className, children, ...other }) => {
  const classes = cx(CLASS_ROOT, className);

  return (
    <div className={classes} {...other}>
      <Bar>
        <BarItem className="social__item">
          <a
            href="https://www.instagram.com/creativemovementstudio"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="instagram" />
          </a>
        </BarItem>
        <BarItem className="social__item">
          <a
            href="https://www.facebook.com/Creative-Movement-Studio-625091384598169"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="facebook" />
          </a>
        </BarItem>
      </Bar>
    </div>
  );
};

Social.propTypes = propTypes;

export default Social;
